// 3rd party
import { Injectable } from '@angular/core';
import { Http, Response, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { PdfJsViewerComponent } from 'ng2-pdfjs-viewer';

// settings
import { StoredFile } from 'app/shared/models/stored-file.model';

@Injectable()
export class StoredFileService {

  constructor(
    private http: Http
  ) { }

  get(identifier?: string, search?: string, orderBy?: string, sortOrder?: string, pageSize?: number, currentPage?: number, filters?: string, fields?: string): Observable<Response> {
    currentPage = currentPage || 1;

    return this.http
      .get('files/' + (identifier ? identifier : '') + '?fields=[' + (fields ? fields : '') + ']' + (search ? '&search=' + search : '') + (orderBy ? '&orderBy=["' + orderBy + (sortOrder ? ' ' + sortOrder : '') + '"]' : '') + (pageSize ? '&pageSize=' + pageSize + '&currentPage=' + currentPage : '') + (filters ? '&filters=[' + filters + ']' : ''))
      .map((res: Response) => res)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  download(files: StoredFile[]): Observable<any> {
    if (!files || files.length === 0) {
      return;
    }

    let serialized = JSON.stringify(files);
    return this.http
      .get('files/download/?files=' + encodeURIComponent(serialized), { responseType: ResponseContentType.Blob })
      .map(res => new Blob([res.blob()], { type: res.headers.get('content-type').toString() }))
      .catch(err => Observable.throw(new Error(err)));
  }

  formatFileSize(bytes: number): string {
    if (bytes < 1024) {
      return bytes + ' Bytes';
    } else if (bytes < 1048576) {
      return (bytes / 1024).toFixed(3) + ' KB';
    } else if (bytes < 1073741824) {
      return (bytes / 1048576).toFixed(3) + ' MB';
    } else {
      return (bytes / 1073741824).toFixed(3) + ' GB';
    }
  }

  formatUserFileName(userFileName: string): string {
    if (!userFileName) {
      return null;
    }

    let idx = userFileName.lastIndexOf('\\') + 1;
    idx = idx >= userFileName.length ? 0 : idx;
    return userFileName.substring(idx);
  }

  view(fileBlob: Blob, isDownload: boolean, pdfViewerRef: PdfJsViewerComponent, fileName: string) {
    const usePdfJsViewer = JSON.parse(localStorage.getItem('usePdfJsViewer') || 'false');
    let type = '';

    if (fileBlob.type === 'application/pdf')
      type = '.pdf';
    else
      type = '.zip';

    if (!isDownload && usePdfJsViewer && fileBlob.type === 'application/pdf') {
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(fileBlob, fileName + type);
      } else {
        pdfViewerRef.pdfSrc = fileBlob;
        pdfViewerRef.refresh();
      }
    } else {
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(fileBlob, fileName + type);
      } else {
        const fileUrl = window.URL.createObjectURL(fileBlob);
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        a.setAttribute('target', '_blank');
        a.setAttribute('download', fileName);
        document.body.appendChild(a);
        a.href = fileUrl;
        a.click();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/stored-file.service.ts